<template>
    <div class="main">

        <el-form label-position="top">
            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18" :md="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                <el-select @change="getTurmas()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo == 9 || $store.state.user.tipo == 12">
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Ano letivo" key="periodo_letivo">
                                <el-select @change="getTurmas()" v-model="filtro.periodo_letivo_id" clearable>
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="16" :md="16">
                            <el-form-item label="Turma" key="turma">
                                <el-select v-model="filtro.turma_id" @change="changeTurma()" clearable filterable>
                                    <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                        <el-option v-for="turma in grupo" :key="turma.id" :label="`${turma.curso.nome} ${turma.nome}`" :value="turma.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Período do Diário" key="periodo">
                                <el-select v-model="filtro.periodo" clearable @change="carregar()">
                                    <el-option v-for="(periodo, i) in turmaSelecionada.periodos_diario" :key="i" :label="periodo" :value="i + 1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10 u-text-right">
                <span v-if="salvando" class="ata-status">Salvando...</span>
                <el-button v-if="ata" @click="imprimir()" :loading="loadingPdf" type="success">IMPRIMIR</el-button>
            </div>
        </el-form>

        <div v-if="ata" class="u-mt-10">
            <div class="ata-cab">
                <strong>{{ ata.cabecalho.titulo }}</strong> - {{ ata.cabecalho.instituicao }} - {{ ata.cabecalho.curso }} {{ ata.cabecalho.turma }}
                <span v-if="ata.atualizacao" class="ata-atualizacao"> (marcações salvas por {{ ata.atualizacao.por }} em {{ ata.atualizacao.em }})</span>
            </div>

            <div class="ata-scroll">
                <table class="ata">
                    <thead>
                        <tr>
                            <th rowspan="2">Nº</th>
                            <th rowspan="2" class="nome">Aluno</th>
                            <th v-for="d in ata.disciplinas" :key="d.id" colspan="4" :title="d.nome">{{ d.abrev }}</th>
                            <th colspan="4" title="Totais do período">TOTAIS</th>
                            <th colspan="7">Causas Prováveis</th>
                            <th colspan="4">Soluções Propostas</th>
                        </tr>
                        <tr>
                            <template v-for="d in ata.disciplinas">
                                <th :key="d.id + 'n'">N</th><th :key="d.id + 'f'">F</th><th :key="d.id + 'a'">AC</th><th :key="d.id + 'p'">%F</th>
                            </template>
                            <th title="Total de faltas">TF</th><th title="Total de aulas compensadas">TAC</th><th title="% de frequência total">%FT</th><th title="Total de aulas dadas">TAD</th>
                            <th v-for="(nome, k) in ata.legendas.causas" :key="'c' + k" :title="nome">{{ k }}</th>
                            <th v-for="(nome, k) in ata.legendas.solucoes" :key="'s' + k" :title="nome">{{ k }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="a in ata.alunos" :key="a.aluno_id + '-' + (a.matricula_id || '')" :class="{ saiu: a.etiqueta }">
                            <td>{{ a.numero }}</td>
                            <td class="nome">{{ a.nome }}<span v-if="a.etiqueta"> ( {{ a.etiqueta }}<span v-if="a.data_etiqueta"> em {{ a.data_etiqueta | data }}</span> )</span></td>
                            <template v-for="d in ata.disciplinas">
                                <td :key="d.id + 'n'" :class="{ baixa: baixa(a.disciplinas[d.id].nota) }">{{ nota(a.disciplinas[d.id].nota) }}</td>
                                <td :key="d.id + 'f'">{{ a.disciplinas[d.id].f }}</td>
                                <td :key="d.id + 'a'" class="azul">{{ a.disciplinas[d.id].ac }}</td>
                                <td :key="d.id + 'p'">{{ a.disciplinas[d.id].pct }}</td>
                            </template>
                            <td>{{ a.tf }}</td><td class="azul">{{ a.tac }}</td><td>{{ a.pct_ft }}</td><td>{{ a.tad }}</td>
                            <td v-for="(nome, k) in ata.legendas.causas" :key="'c' + k" :title="'Aluno: ' + a.nome + ' | Causa: ' + nome">
                                <input type="checkbox" :value="String(k)" v-model="a.causas" :disabled="!a.editavel" @change="salvarAluno(a)">
                            </td>
                            <td v-for="(nome, k) in ata.legendas.solucoes" :key="'s' + k" :title="'Aluno: ' + a.nome + ' | Solução: ' + nome">
                                <input type="checkbox" :value="String(k)" v-model="a.solucoes" :disabled="!a.editavel" @change="salvarAluno(a)">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="ata-legendas">
                <div><strong>Causas Prováveis:</strong> <span v-for="(nome, k) in ata.legendas.causas" :key="k">{{ k }} - {{ nome }}; </span></div>
                <div><strong>Soluções Propostas:</strong> <span v-for="(nome, k) in ata.legendas.solucoes" :key="k">{{ k }} - {{ nome }}; </span></div>
                <div class="u-mt-10">N nota; F faltas; AC aulas compensadas; %F % de frequência; TF total de faltas; TAC total de aulas compensadas; %FT % de frequência total; TAD total de aulas dadas.</div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        loading: false,
        loadingPdf: false,
        salvando: 0,
        filtro: { instituicao_id: '', periodo_letivo_id: '', turma_id: '', periodo: '' },
        turmas: [],
        turmaSelecionada: {},
        ata: null
    }),
    filters: {
        data (v) { return v ? String(v).substr(0, 10).split('-').reverse().join('/') : '' }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

        if (this.$store.state.user.tipo <= 3 || this.$store.state.user.tipo == 9 || this.$store.state.user.tipo == 12) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.getTurmas();
    },
    methods: {
        nota (v) {
            if (v === null || v === undefined) return '';
            return Number(v).toFixed(Number(v) === Math.round(Number(v) * 10) / 10 ? 1 : 2).replace('.', ',');
        },
        baixa (v) {
            return v !== null && v !== undefined && Number(v) < this.ata.media_minima;
        },
        getTurmas () {
            this.filtro.turma_id = '';
            this.turmaSelecionada = {};
            this.ata = null;

            if (!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id) {
                this.turmas = [];
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.turmas = response.data;
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        changeTurma () {
            const periodoAnterior = this.filtro.periodo;
            this.turmaSelecionada = {};
            this.ata = null;

            for (let grupo in this.turmas) {
                for (let t of this.turmas[grupo]) {
                    if (t.id == this.filtro.turma_id) {
                        this.turmaSelecionada = t;
                    }
                }
            }

            // Mantém o período já escolhido, se a nova turma também o tiver.
            const periodos = this.turmaSelecionada.periodos_diario || [];
            this.filtro.periodo = periodoAnterior && periodoAnterior <= periodos.length ? periodoAnterior : '';
            this.carregar();
        },
        validar () {
            if (!this.filtro.turma_id) {
                window.eventBus.$emit('alert', {msg: 'Selecione a turma.', type: 'warning'});
                return false;
            }
            if (!this.filtro.periodo) {
                window.eventBus.$emit('alert', {msg: 'Selecione o período do diário.', type: 'warning'});
                return false;
            }
            return true;
        },
        carregar () {
            if (!this.filtro.turma_id || !this.filtro.periodo) {
                this.ata = null;
                return;
            }

            this.loading = true;
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ata-conselho/getAta`, { turma_id: this.filtro.turma_id, periodo: this.filtro.periodo }, this.$store.getters.getHeaderAuth).then(response => {
                this.loading = false;
                if (response.data.erro) {
                    this.ata = null;
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    return;
                }
                this.ata = response.data;
            }).catch((error) => { this.loading = false; this.$store.commit('throwException', error); });
        },
        // Salva as marcações do aluno assim que um checkbox é clicado.
        salvarAluno (aluno) {
            this.salvando++;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ata-conselho/store`, {
                turma_id: this.filtro.turma_id,
                periodo: this.filtro.periodo,
                alunos: [{ aluno_id: aluno.aluno_id, causas: aluno.causas, solucoes: aluno.solucoes }]
            }, this.$store.getters.getHeaderAuth).then(response => {
                this.salvando--;
                if (response.data.erro) {
                    window.eventBus.$emit('alert', {msg: response.data.erro, type: 'warning'});
                    this.carregar();
                }
            }).catch((error) => { this.salvando--; this.$store.commit('throwException', error); this.carregar(); });
        },
        imprimir () {
            if (!this.validar()) return;

            this.loadingPdf = true;
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/ata-conselho/render`, { turma_id: this.filtro.turma_id, periodo: this.filtro.periodo }, this.$store.getters.getHeaderAuthExcel).then(response => {
                this.loadingPdf = false;

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const novaAba = window.open(url, '_blank');
                if (!novaAba) { window.location.href = url; }
            }).catch((error) => { this.loadingPdf = false; window.eventBus.$emit('alert', {msg: 'Erro ao gerar a ata.', type: 'warning'}); this.$store.commit('throwException', error); });
        }
    }
}
</script>
<style scoped>
    .ata-status { color: #777; font-size: 12px; margin-right: 10px; }
    .ata-cab { margin-bottom: 6px; }
    .ata-atualizacao { color: #777; font-size: 12px; }
    .ata-scroll { overflow-x: auto; max-height: 70vh; border: 1px solid #ccc; }
    table.ata { border-collapse: collapse; font-size: 12px; background: #fff; }
    table.ata th { background: #005b8f; color: #fff; padding: 3px 5px; border: 1px solid #000; position: sticky; top: 0; }
    table.ata td { border: 1px solid #000; padding: 2px 5px; text-align: center; }
    table.ata td.nome, table.ata th.nome { text-align: left; min-width: 230px; white-space: nowrap; }
    table.ata tr.saiu td { background: #d0d0d0; font-weight: bold; }
    .baixa { color: #d00000; }
    .azul { color: #0000d0; }
    .ata-legendas { margin-top: 10px; font-size: 12px; color: #444; }
</style>
